import React, { useState } from 'react';
import { resetUserPreview, getUsersListSuccess } from '../../../actions/Users/UserAction';
import { useDispatch, useSelector } from 'react-redux';
import Constants from '../../../Constants';
import Api from '../../../Api';
import FlashMessages from '../../Common/Messages/FlashMessages';
import { ModalContainer } from '../../Common';
import { useNavigate } from 'react-router';

const api = new Api();

export const CancelInvite = (props) => {
  const { userId } = props;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState();
  const [isBusy, setIsBusy] = useState(false);
  const previewUser = useSelector(state => state.Users.previewUser);
  const usersList = useSelector(state => state.Users.usersList);
  const dispatch = useDispatch();

  const onSubmit = async ({ setOpened }) => {
    setErrorMessage();
    setIsBusy(true);
    try {
      await api.delData(Constants.apiUrls.userDetails + userId);
      setIsBusy(false);
      const currentUserGuid = previewUser.guid;
      const newUserList = { ...usersList };
      newUserList.contents = usersList.contents.filter((user) => user.guid !== currentUserGuid);
      dispatch(getUsersListSuccess(newUserList));
      dispatch(resetUserPreview());
      setOpened(false);
      navigate('/users', { statusMessage: `User Invite to ${previewUser.email} was successfully cancelled.` });
    } catch (err) {
      setIsBusy(false);
      console.error(err);
      setErrorMessage(err.response ? err.response.data.error : 'Cannot complete action. Please try again.')
    }
  };

  const hideFlashMessage = () => {
    setErrorMessage();
  };

  const getButtonToggle = (opened, setOpened) => {
    return (
      <button data-testid="cancel-invite-btn" className="btn btn-default cancel-invite-btn" onClick={() => setOpened(true)}>
        <i className="fal fa-ban lsn-removelink mRight-5" />
        Cancel Invite
      </button>
    )
  }

  const getModalBody = () => {
    return (
      <React.Fragment>
        <FlashMessages
          scope="CancelInvite"
          classNames="fl-cancel-invite"
          close={hideFlashMessage}
          type='error'
          msg={errorMessage}
          open={!!errorMessage}
        />
        Canceling this invite will deactivate any previously sent activation links to this email address and
        remove this user from the system.
      </React.Fragment>
    );
  }

  const onCancel = ({ setOpened }) => {
    setOpened(false);
  }

  return (
    <ModalContainer
      title='Cancel Invite'
      size='small'
      showCloseIcon
      asToggleButtonFn={getButtonToggle}
      text={getModalBody()}
      buttons={[
        {
          onClick: onSubmit,
          label: 'Cancel Invite',
          disabled: isBusy
        },
        {
          onClick: onCancel,
          label: 'Go Back',
          disabled: isBusy
        }
      ]}
    />
  );
}

export default CancelInvite;
